import React from 'react';
import MapWidget from './MapWidget';
import PropertyHours from './PropertyHours';
import PropertyOverviewForm from './PropertyOverviewForm';
import PropertyDescriptionForm from './PropertyDescriptionForm';
import PropertyDetailsForm from './PropertyDetailsForm';
import PhotosForm from './PhotosForm';
import PropertyFeaturesForm from './PropertyFeaturesForm';
import HotelContactModal from './HotelContactModal';
import Layout from '../../../components/Layout';
import Landmarks from './Landmarks';
import RoomsForm from './RoomsForm';
import { Form } from 'react-final-form'
import {
  FormGroup,
  Button,
  ButtonToolbar,
} from 'react-bootstrap';
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import moment from 'moment';
import PropertyOverview from './PropertyOverviewContainer';
import HotelContacts from './HotelContacts';
import PropertyDetails from './PropertyDetails';
import Photos from './Photos';
import PropertyFeatures from './PropertyFeatures';

class AddNewHotel extends React.Component {
  constructor(props) {
    super(props);
    var agrs = '';
    this.state = {
      show: false,
      hotel: {
      },
      ModalData: { values: true },
      propertyDesc: { value: "" },
      landmarkData: { value: "" },
      roomData: { value: "" },
      brandList: ""
    };

    this.handleAddHotelContact = this.handleAddHotelContact.bind(this);
    this.handleClose = this.handleClose.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddContact = this.handleAddContact.bind(this);
    this.handleModalData = this.handleModalData.bind(this);
    this.handleLandmrakData = this.handleLandmrakData.bind(this);
    this.handleRoomData = this.handleRoomData.bind(this);

  }

  componentWillMount() {
    this.props.requestBrandOptions();
  }

  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleAddHotelContact() {
    this.setState({ show: true });
  }
  onSubmit = (values) => {
    //let data = convertToRaw(this.state.editorState.getCurrentContent());
    //debugger
    let features = {
      features: values.features
    }
    let year_built =  moment(values.year_built) 
     if (moment.isMoment(year_built)) {
      values.year_built = year_built.format('YYYY-MM-DD');
     }
     
     let year_remodeled =  moment(values.year_remodeled) 
     if (moment.isMoment(year_remodeled)) {
      values.year_remodeled = year_remodeled.format('YYYY-MM-DD');
     }
    //let parent_id = 0;
    //if(values.parent_id[0]){
      let parent_id = values.parent_id !== undefined ? values.parent_id[0] : 0
    
    values.parent_id = parent_id
    values.features = features;
    values.contactData = this.state.ModalData
    values.description = this.state.propertyDesc
    values.landmarkData = this.state.landmarkData
    values.roomData = this.state.roomData
    //values.parent_id = 
    //console.log('values =' + values)
    //return false;
    this.props.addHotel(values)
  }
  handleClose() {
    this.setState({ show: false });
  }

  

  handleModalData(values) {
    this.setState({ ModalData: values }, () =>
      console.log(this.state.ModalData));
  }
  handleAddContact(Values) {
    console.log('handleAddContact')
    this.setState({ propertyDesc: Values }, () =>
      console.log(this.state.propertyDesc));

    //debugger;
  }
  handleLandmrakData(Values) {
    console.log('handleLandmrakData');
    this.setState({ landmarkData: Values }, () =>
      console.log(this.state.landmarkData));
  }
  handleRoomData(Values) {
    console.log('handleRoomData');
    this.setState({ roomData: Values }, () =>
      console.log(this.state.roomData));
  }

  render() {
    const enableHours = false;
    return (
      <Layout>
        <div className="container-fluid hotel-detail-container">
          <div className="row">
            <div className="col-md-12 hotel-detail-header">
              <h1>Add Hotel</h1>
              <hr className="hrTag" />
            </div>
          </div>
            {/* <Form 
              // onSubmit={this.onSubmit}
              // initialValues={this.state.hotel}
              // render={({ handleSubmit, pristine, invalid }) => (
              // <form onSubmit={handleSubmit}> */}
            <div className="row">
              <div className="col-md-12">
                <h1 className="hotel-detail-subhead">Property Overview</h1>
              </div>
              <PropertyOverview {...this.props} isAddHotel={true} addHotel={this.props.addHotel}/>
              {/* <div className="col-md-12">
                <HotelContactModal
                  {...this.props}
                  handleSubmit={this.handleModalData}
                  setState={ModalData => { this.setState(ModalData) }}
                />
              </div> */}
              {/* <div className="col-md-6">
                <HotelContacts
                  hotel={this.props.hotel}
                  addHotelContact={this.props.addHotelContact}
                  removeHotelContact={this.props.removeHotelContact}
                  isAddHotel={true}
                />
              </div> */}
            </div>

              {/*<div className="row hotel-detail-map">
                <MapWidget hotel={this.state.hotel} />
              </div> 

               <div className="row">
                <div className="col-md-12">
                  <h1 className="hotel-detail-subhead">Property Details</h1>
                  <PropertyDescriptionForm
                  {...this.props}
                  onSubmit={this.onSubmit}
                  content={this.state.hotel}
                  handleData={this.handleAddContact}
                  isAddHotel={true}
                  />
                  <PropertyDetails {...this.props} editHotel={this.props.editHotel} isAddHotel={true}/>
                </div>
              </div> */}

              {/* {enableHours && (
                <div className="row">
                  <div className="col-md-12">
                    <h1 className="hotel-detail-subhead">Hours</h1>
                    <PropertyHours hotel={this.state.hotel} />
                  </div>
                </div>
              )} */}

              {/* <PhotosForm
                {...this.props}
                handleClose={this.handleClose}
              /> */}
              {/* <Photos
                {...this.props}
                editHotelPhoto={this.props.editHotelPhoto}
                addHotelPhoto={this.props.addHotelPhoto}
                removeHotelPhoto={this.props.removeHotelPhoto}
                sortHotelPhotos={this.props.sortHotelPhotos}
                isAddHotel={true}
              /> */}

              {/* <PropertyFeatures                    
                {...this.props}
               onSubmit={this.onSubmit}
               isAddHotel={true}
              /> */}
              {/* <PropertyFeatures hotel={this.state.hotel} editHotelFeatures={this.props.editHotelFeatures} /> */}
              {/* <Landmarks
                {...this.props}
                handleSubmit={this.handleLandmrakData}
                isAddHotel={true}
              />
              <RoomsForm
                {...this.props}
                handleSubmit={this.handleRoomData}
              /> */}

              {/* <div className="row">
                <div className="col-md-12">
                  <FormGroup>
                    <ButtonToolbar>
                      <Button bsStyle="success" type="submit">
                        Save
                      </Button>
                      <Button bsStyle="success">
                        Discard Changes
                      </Button>
                    </ButtonToolbar>
                  </FormGroup>
                </div>
              </div> */}
            {/* </form>
            )} */}
         
        </div>
      </Layout>
    );
  }
}

export default AddNewHotel;



// WEBPACK FOOTER //
// src/routes/hotels/components/AddNewHotel.js